/**
 * Best-effort console usage tracking.
 *
 * Usage telemetry must never block navigation or make the console unusable
 * when the tracking endpoint/KV is unavailable, so callers intentionally do
 * not await this request.
 */
import { createCaller } from '@parkify/api-client'

export function trackUsage(
  apiBase: string,
  authHeaders: HeadersInit,
  event: string,
  data?: Record<string, unknown>,
): void {
  void createCaller(apiBase)('/api/usage/track', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders },
    body: JSON.stringify({ event, data }),
  }).catch(() => {
    // Telemetry is non-critical; a failed event must not surface to operators.
  })
}
